// Signed-out hero copy. Every line leads with the brand truth: people sit out
// because they fear how they sound, and Aeon removes that fear. The same set
// runs on the landing site's headline test; keep them in step.
export const HERO_LINES = [
  {
    title: 'Sing the one you always skip.',
    subtitle: 'With Aeon nobody sounds bad, so the song you never dared to queue is finally yours.',
  },
  {
    title: 'Nobody sits this one out.',
    subtitle: 'Aeon makes everyone sound incredible, so the whole room sings instead of watching.',
  },
  {
    title: 'Stop mouthing the words.',
    subtitle: 'Most people sit out because they are afraid of how they sound. Aeon takes that away.',
  },
  {
    title: "Sing like it's just you in the car.",
    subtitle: 'That voice, in a room full of people. Aeon makes everyone sound incredible.',
  },
] as const;

export type HeroLine = (typeof HERO_LINES)[number];

const DAY_MS = 86_400_000;

/** One line per day, stable across reloads, cycling through the set. */
export function pickHeroLine(now = new Date()): HeroLine {
  const day = Math.floor(now.getTime() / DAY_MS);
  const index = ((day % HERO_LINES.length) + HERO_LINES.length) % HERO_LINES.length;
  return HERO_LINES[index] ?? HERO_LINES[0];
}
